import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectToken, selectUser } from '../../features/auth/authSlice';

const AdminRoute = ({ children }) => {
  const token = useSelector(selectToken);
  const user = useSelector(selectUser);

  if (!token) {
    return <Navigate to="/auth/login" replace />;
  }

  if (user?.role === 'SURGEON') {
    return <Navigate to="/surgeon/profile" replace />;
  }

  if (user?.role === 'USER') {
    return <Navigate to="/user" replace />;
  }

  if (user?.role !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
